import { Component } from '@angular/core';

@Component({
  selector: 'fieldmagic-indent',
  template: `
    <div class="d-flex d-flex-gap align-items-center pl-2">
      <div class="bg-indent"></div>
      <ng-content></ng-content>
    </div>
  `,
})
export class IndentedContentComponent {}